<script lang="ts" setup>
import type { MailAccountType } from '@/types/dashboard/mail'
import { computed } from 'vue'

const props = defineProps<{
  type: MailAccountType
  size?: number | string
}>()

const iconConfig = computed(() => {
  switch (props.type) {
    case 'mailbox':
      return { icon: 'mdi-email', color: '#64b5f6' }
    case 'alias':
      return { icon: 'mdi-email-arrow-right', color: '#ffb74d' }
    case 'list':
      return { icon: 'mdi-email-multiple', color: '#ba68c8' }
    case 'group':
      return { icon: 'mdi-email-sync', color: '#81c784' }
    case 'admin':
      return { icon: 'mdi-shield-account', color: '#ef5350' }
    case 'domain_admin':
      return { icon: 'mdi-shield-key', color: '#ffab40' }
    default:
      return { icon: 'mdi-email', color: '#64b5f6' }
  }
})
</script>

<template>
  <v-icon
    :icon="iconConfig.icon"
    :size="size || 20"
    :color="iconConfig.color"
  />
</template>
